<batch-upload-notification-bar></batch-upload-notification-bar>
<div class="container" [ngClass]="{ 'external': external, 'ptp-fullview-hack': dateSelected }">
  <div class="upload-images">
    <div id="canvas" hidden></div>
    <div class="upload-image-dropzone" [ngClass]="{filled: savedTickets.length}">
      <div *ngIf="loader.active" class="loader-container">
        <my-loader></my-loader>
        <p *ngIf="loader.type === 'uploading'" translate>Uploading Ticket Images</p>
        <p *ngIf="loader.type === 'analyzing'" translate>{{ savedTickets.length }}/{{ uploadTotal }} Tickets Analyzed</p>
      </div>
      <ng-container *ngIf="savedTickets.length && selectedRecordIndex === null">
        <div *ngFor="let ticket of savedTickets | sort: 'uploadIndex'; let i = index" class="image-container {{ viewerType }}">
          <div class="detection-label-container" (click)="toggleView('single', i)">
            <div *ngIf="ticket.ticketNumber" class="detection-label">
              Ticket #:<br/><span class="data">{{ ticket.ticketNumber }}</span>
            </div>
            <div *ngIf="ticket.ticketDate" class="detection-label date">
              Ticket Date:<br/><span class="data">{{ ticket.ticketDate }}</span>
            </div>
            <div *ngIf="ticket.quantity" class="detection-label quantity">
              Quantity:<br/><span class="data">{{ ticket.quantity }}</span>
            </div>
          </div>
          <div class="no-ticket-image-container">
            <ng-container *ngFor="let image of ticket.attachments">
              <image-editor
                *ngIf="image.file" 
                [id]="ticket.id" 
                [imageUrl]="image.file"
                (onSave)="onSave($event, i)" 
                (onImageClick)="toggleView('single', i)">
              </image-editor>
            </ng-container>
          </div>
          <!-- <image-editor *ngIf="ticket.image" [id]="ticket.id" [imageUrl]="ticket.image"
          (onSave)="saveImage($event)" (onImageClick)="toggleView('single', i)"></image-editor> -->
          <div *ngIf="!ticket.image" class="no-image">
            <i class="icon-no-results" (click)="toggleView('single', i)"></i>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedRecordIndex !== null">
        <div class="image-container single">
          <ng-container *ngIf="savedTickets.length > 0 && savedTickets[selectedRecordIndex]">
            <ng-container *ngFor="let image of savedTickets[selectedRecordIndex].attachments">
              <image-editor 
                *ngIf="savedTickets[selectedRecordIndex] && image && image.file" 
                [id]="savedTickets[selectedRecordIndex].id"
                [imageUrl]="image.file"
                [attachment]="image"
                (onSave)="onSave($event, selectedRecordIndex)"
                (onDelete)="onDelete($event, selectedRecordIndex)"  
              >
              </image-editor>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <div class="viewer-controls" [ngClass]="{'has-images': savedTickets.length}">
        <div *ngIf="savedTickets.length" class="left-controls">
          <ng-container *ngIf="savedTickets.length > 1 && !external">
            <mat-icon [ngClass]="{'active': viewerType === 'single'}" (click)="toggleView('single', 0)">insert_photo</mat-icon>
            <mat-icon [ngClass]="{'active': viewerType === 'grid'}" (click)="toggleView('grid')">grid_on</mat-icon>
          </ng-container>
          <p *ngIf="viewerType === 'grid'">{{ savedTickets.length }} TICKET<span *ngIf="savedTickets.length > 1">S</span></p>
          <p *ngIf="viewerType === 'single'">TICKET {{ selectedRecordIndex + 1 }} OF {{ savedTickets.length }}</p>
        </div>
        <input type="file" multiple name="file" id="file" class="inputfile" (change)="fileChange($event, selectedRecordIndex)" #fileInput/>
        <div [style.margin-top]="newAttachments.length ? '0' : '20vh'">
          <ng-container *ngIf="!editMode && savedTickets.length < 1" >
            <label translate>Create Ticket</label>
            <mat-button-toggle-group [value]="attachmentsToggle" (change)="onAttachmentsToggle($event)">
              <mat-button-toggle value="single">Single</mat-button-toggle>
              <mat-button-toggle value="multiple">Multiple</mat-button-toggle>
            </mat-button-toggle-group>
          </ng-container>
          <label [style.margin-top]="'16px'" class="upload-label" for="file" *ngIf="!savedTickets.length">
            <i class="icon-upload"></i>
            <span translate>Drag and drop images or choose images</span>
          </label>
        </div>
        <button class="btn btn-secondary upload" *ngIf="!savedTickets.length">CHOOSE IMAGES</button>
        <button class="btn btn-secondary upload" *ngIf="savedTickets.length && selectedRecordIndex !== null" >ADD MORE IMAGES</button>
      </div>
      <!-- new ticket images -->
      <ng-container *ngIf="selectedRecordIndex === null">
        <div class="image-container single">
          <ng-container *ngFor="let image of newAttachments">
            <image-editor 
              [id]="null"
              [newTicket]="true"
              [imageUrl]="image.file"
              [attachment]="image"
              (onSave)="onSave($event, null)"
              (onDelete)="onDelete($event, null)"  
            >
            </image-editor>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="upload-fields" [ngClass]="{ 'ptp-field-visibilty-hack': external }">
    <a *ngIf="!external" class="back" (click)="close()">&times; Close</a>
    <ng-container *ngIf="!external">
      <div class="form-container">
        <div class="ticket-fields">
          <div class="flex-field-group">
            <div class="flex-field flex-field__fill" *ngIf="ticketNumberVisible()">
              <label translate>Ticket Number</label>
              <mat-form-field>
                <input
                  *ngIf="selectedRecordIndex === null || !savedTickets[selectedRecordIndex]"
                  type="text" aria-label="{ 'Ticket Number' | translate }"
                  (change)="model.ticketNumber = $event.target.value"
                  (focus)="fieldActive = true" (blur)="fieldActive = false"
                  matInput [(ngModel)]="model.ticketNumber" name="ticketNumber"
                >
                <input
                  *ngIf="selectedRecordIndex !== null && savedTickets[selectedRecordIndex]"
                  type="text" aria-label="{ 'Ticket Number' | translate }"
                  (change)="model.ticketNumber = $event.target.value"
                  (focus)="fieldActive = true" (blur)="fieldActive = false"
                  matInput [(ngModel)]="savedTickets[selectedRecordIndex].ticketNumber"
                  [name]="'ticketNumber-'+ selectedRecordIndex"
                >
              </mat-form-field>
            </div>

            <div class="flex-field flex-field__fill">
              <label translate>Ticket Date</label>
              <mat-form-field>
                <input
                  name="date"
                  aria-label="{ 'Date' | translate }"
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="model.ticketDate"
                  (focus)="fieldActive = true"
                  (blur)="fieldActive = false"
                >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              </mat-form-field>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>

          <div class="flex-field-group">
            <div class="flex-field quantity">
              <label translate>Quantity</label>
              <mat-form-field>
                <input type="text" aria-label="{ 'Quantity' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                      matInput [(ngModel)]="model.quantity" name="quantity">
              </mat-form-field>
            </div>

            <div class="flex-field quantity-type">
              <label translate>Quantity Type</label>
              <mat-form-field>
                <input type="text" aria-label="{ 'Quantity' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                      matInput [(ngModel)]="model.quantityType" name="quantity-type">
              </mat-form-field>
            </div>
          </div>

          <div class="flex-field-group">
            <div class="flex-field truck">
              <label translate>Truck Number</label>
              <mat-form-field>
                <input type="text" aria-label="{ 'Truck Number' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                      matInput [(ngModel)]="model.truckNumber" name="truck-number">
              </mat-form-field>
            </div>

            <div class="flex-field quantity-type">
              <label translate>Truck Type</label>
              <mat-form-field>
                <input type="text" aria-label="{ 'Truck Type' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                      matInput [(ngModel)]="model.truckType" name="truck-type">
              </mat-form-field>
            </div>
          </div>

          <div class="flex-field-group">
            <div class="flex-field customer-fields">
              <label translate>Customer</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Customer' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.customerName" name="customerName">
                </mat-form-field>
            </div>
  
            <div class="flex-field job-fields">
              <label translate>Job</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Job' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.jobName" name="jobName">
                </mat-form-field>
            </div>
          </div>

          <div class="flex-field-group">
            <div class="flex-field location-owner-fields">
              <label translate>Location Owner</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Location Owner' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.locationOwner" name="locationOwner">
                </mat-form-field>
            </div>
  
            <div class="flex-field origin-fields">
              <label translate>Origin</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Origin' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.origin" name="origin">
                </mat-form-field>
            </div>
          </div>

          <div class="flex-field-group">
            <div class="flex-field destination-fields">
              <label translate>Destination</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Destination' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.destination" name="destination">
                </mat-form-field>
            </div>
  
            <div class="flex-field material-fields">
              <label translate>Material</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Material' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.material" name="material">
                </mat-form-field>
            </div>
          </div>

          <div class="flex-field-group">
            <div class="flex-field driver-fields">
              <label translate>Driver</label>
                <mat-form-field>
                  <input type="text" aria-label="{ 'Driver' | translate }" (focus)="fieldActive = true" (blur)="fieldActive = false"
                    matInput [(ngModel)]="model.driverName" name="driverName">
                </mat-form-field>
            </div>
  
            <div class="flex-field spacer-fields">

            </div>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="reference-label">
          <img src="assets/img/insert-link-24-px.svg" class="icon-info">

          <span>References</span>
        </div>

        <div class="customer-reference-fields">
          <div class="field-group dropdown customer-field">
            <label translate>Customer</label>
            <customer-reference-selector
              #customerReferenceSelector
              placeholder=""
              (referenceFocused)="onCustomerReferenceFocused()"
              (referenceSelected)="onCustomerReferenceSelected($event)"
              (referenceCreated)="onCustomerReferenceCreated($event)"
              (onBlur)="onCustomerReferenceBlur()"
              [(visible)]="isCustomerFieldVisible"
            ></customer-reference-selector>
          </div>
          <div (click)="onCustomerReferenceToggle()" class="customer-reference-fields__more">
            <span *ngIf="!customerFieldsVisible" class="icon-down-arrow"></span>
            <span *ngIf="customerFieldsVisible" class="icon-up-arrow"></span>
            More
          </div>
          <div *ngIf="customerFieldsVisible" class="customer-reference-fields__fields">
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>CODE</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.customerCode ? selectedCustomerReference.customerCode : ''" matInput disabled type="text" aria-label="{ 'Code' | translate }" name="customer-code" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>EMAIL</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.email ? selectedCustomerReference.email: ''" matInput disabled type="text" aria-label="{ 'EMail' | translate }" name="customer-email" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>ADDRESS 1</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.customerAddress1 ? selectedCustomerReference.customerAddress1 : ''" matInput disabled type="text" aria-label="{ 'Customer Address 1' | translate }" name="customer-address-1" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>CITY</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.city ? selectedCustomerReference.city : ''" matInput disabled type="text" aria-label="{ 'City' | translate }" name="customer-city" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>STATE</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.customerState ? selectedCustomerReference.customerState : ''" matInput disabled type="text" aria-label="{ 'State' | translate }" name="customer-state" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>ZIP CODE</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.customerZipcode ? selectedCustomerReference.customerZipcode : ''" matInput disabled type="text" aria-label="{ 'Zip Code' | translate }" name="customer-zip" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field flex-field__fill">
                <label translate>PHONE NUMBER</label>
                <mat-form-field>
                  <input [value]="!!selectedCustomerReference && selectedCustomerReference.phoneNumber ? selectedCustomerReference.phoneNumber : ''" matInput disabled type="text" aria-label="{ 'Phone Number' | translate }" name="customer-phone-number" />
                </mat-form-field>
              </div>
            </div>
          </div>
          </div>

        <div class="job-reference-fields">
          <div class="field-group dropdown job-field">
            <label translate>Job</label>
            <job-reference-selector
              #jobReferenceSelector
              hasControls="{{ true }}"
              placeholder=""
              (referenceFocused)="onJobReferenceFocused()"
              (referenceSelected)="onJobReferenceSelected($event)"
              (referenceCreated)="onJobReferenceCreated($event)"
              (onBlur)="onJobReferenceBlur()"
              [(visible)]="isJobFieldVisible"
            ></job-reference-selector>
          </div>
          <div (click)="onJobReferenceToggle()" class="job-reference-fields__more">
            <span *ngIf="!jobFieldsVisible" class="icon-down-arrow"></span>
            <span *ngIf="jobFieldsVisible" class="icon-up-arrow"></span>
            More
          </div>
          <div *ngIf="jobFieldsVisible" class="job-reference-fields__fields">
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>CODE</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.jobCode ? selectedJobReference.jobCode : ''" matInput disabled type="text" aria-label="{ 'Code' | translate }" name="job-code" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>ORDER NUMBER</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.orderNumber ? selectedJobReference.orderNumber: ''" matInput disabled type="text" aria-label="{ 'Order Number' | translate }" name="job-order-number" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>MATERIAL</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.material ? selectedJobReference.material : ''" matInput disabled type="text" aria-label="{ 'Material' | translate }" name="job-material" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>INVOICE RATE</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.invoiceRate ? selectedJobReference.invoiceRate : ''" matInput disabled type="text" aria-label="{ 'Invoice Rate' | translate }" name="job-invoice-rate" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>HAUL RATE</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.haulRate ? selectedJobReference.haulRate : ''" matInput disabled type="text" aria-label="{ 'Haul Rate' | translate }" name="job-haul-rate" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>ORIGIN</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.origin ? selectedJobReference.origin : ''" matInput disabled type="text" aria-label="{ 'Origin' | translate }" name="job-origin" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field flex-field__fill">
                <label translate>DESTINATION</label>
                <mat-form-field>
                  <input [value]="!!selectedJobReference && selectedJobReference.destination ? selectedJobReference.destination : ''" matInput disabled type="text" aria-label="{ 'Destination' | translate }" name="job-destination" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="driver-reference-fields">
          <div class="field-group dropdown driver-field">
            <label translate>Driver</label>
            <driver-reference-selector
              #driverReferenceSelector
              hasControls="{{ true }}"
              placeholder=""
              (referenceFocused)="onDriverReferenceFocused()"
              (referenceSelected)="onDriverReferenceSelected($event)"
              (referenceCreated)="onDriverReferenceCreated($event)"
              (onBlur)="onDriverReferenceBlur()"
              [(visible)]="isDriverFieldVisible"
            ></driver-reference-selector>
          </div>
          <div (click)="onDriverReferenceToggle()" class="driver-reference-fields__more">
            <span *ngIf="!driverFieldsVisible" class="icon-down-arrow"></span>
            <span *ngIf="driverFieldsVisible" class="icon-up-arrow"></span>
            More
          </div>
          <div *ngIf="driverFieldsVisible" class="driver-reference-fields__fields">
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>CODE</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.driverCode ? selectedDriverReference.driverCode : ''" matInput disabled type="text" aria-label="{ 'Code' | translate }" name="driver-code" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>TRUCK NUMBER</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.truckNumber ? selectedDriverReference.truckNumber: ''" matInput disabled type="text" aria-label="{ 'Truck Number' | translate }" name="driver-truck-number" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>TRUCK TYPE</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.truckType ? selectedDriverReference.truckType : ''" matInput disabled type="text" aria-label="{ 'Truck Type' | translate }" name="driver-truck-type" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>CDL</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.cdl ? selectedDriverReference.cdl : ''" matInput disabled type="text" aria-label="{ 'CDL' | translate }" name="driver-cdl" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field">
                <label translate>CARRIER</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.haulRate ? selectedDriverReference.haulRate : ''" matInput disabled type="text" aria-label="{ 'Carrier' | translate }" name="driver-carrier" />
                </mat-form-field>
              </div>
              <div class="flex-field">
                <label translate>EMAIL</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.email ? selectedDriverReference.email : ''" matInput disabled type="text" aria-label="{ 'Email' | translate }" name="driver-email" />
                </mat-form-field>
              </div>
            </div>
            <div class="flex-field-group">
              <div class="flex-field flex-field__fill">
                <label translate>PHONE NUMBER</label>
                <mat-form-field>
                  <input [value]="!!selectedDriverReference && selectedDriverReference.phoneNumber ? selectedDriverReference.phoneNumber : ''" matInput disabled type="text" aria-label="{ 'Phone Number' | translate }" name="driver-phone-number" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="form-actions" *ngIf="savedTickets.length <= 1">
        <button class="btn btn-primary" (click)="batchRecordOperation()" translate>
          <span *ngIf="!editMode">Create</span><span *ngIf="editMode">Edit</span> Ticket and Close
        </button>
        <button class="btn btn-default" (click)="batchRecordOperation(true)" translate>
          <span *ngIf="!editMode">Create</span><span *ngIf="editMode">Edit</span> and Add Another
        </button>
      </div>
      <div class="form-actions" *ngIf="selectedRecordIndex === null && savedTickets.length > 1">
        <button type="submit" class="btn btn-primary" [disabled]="loader.active" (click)="batchRecordOperation()" translate>
          <span *ngIf="editMode">Edit Tickets</span>
          <span *ngIf="!editMode">Finish Editing</span>
        </button>
        <button *ngIf="!editMode" [disabled]="loader.active" class="btn btn-primary-alt" (click)="batchRecordOperation(false, false)" translate>
          Edit Tickets
        </button>
        <button *ngIf="uploadFiles.length" class="btn btn-default" (click)="reset()" translate>
          Start Over
        </button>
        <button *ngIf="editMode" class="btn btn-default" (click)="close()" translate>
          Cancel
        </button>
      </div>
      <div class="form-actions" *ngIf="selectedRecordIndex !== null && savedTickets.length > 1">
        <button class="btn btn-primary" (click)="close(savedTickets[selectedRecordIndex])" translate>
          Finish
        </button>
        <button *ngIf="selectedRecordIndex > 0" class="btn btn-primary-alt" (click)="previousTicket(savedTickets[selectedRecordIndex])" translate>
          Prev Ticket
        </button>
        <button *ngIf="savedTickets.length !== (selectedRecordIndex + 1)" class="btn btn-primary-alt" (click)="nextTicket(savedTickets[selectedRecordIndex])" translate>
          Next Ticket
        </button>
        <a *ngIf="savedTickets.length !== (selectedRecordIndex + 1)" (click)="reset()" translate>
          Start Over
        </a>
      </div>
    </ng-container>
    <ng-container *ngIf="external && !dateSelected">
      <div class="form-container">
        <div class="ticket-fields">
          <div class="flex-field-group">
            <div class="flex-field flex-field__fill">
              <label translate>Ticket Date</label>
              <mat-form-field>
                <input
                  name="date"
                  aria-label="{ 'Date' | translate }"
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="model.ticketDate"
                  (focus)="fieldActive = true"
                  (blur)="fieldActive = false"
                >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              </mat-form-field>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
